import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  {
    path: '*',
    redirect: 'Home'
  },
  {
    path: '/home',
    // name: 'Home',
    component: () => import('../views/Reception/Home.vue'),
    children: [
      {
        path: '/',
        name: 'StoreList',
        component: () => import('../views/Reception/StoreList.vue')
      },
      {
        path: '/store/:BusinessId',
        name: 'Store',
        component: () => import('../views/Reception/Store.vue')
      },
      {
        path: '/reservation',
        name: 'Reservation',
        component: () => import('../views/Reception/Reservation.vue')
      }
    ]
  },
  {
    path: '/login',
    name: 'Login',
    component: () => import('../views/Backstage/Login.vue')
  },
  {
    path: '/backstage',
    // name: 'Backstage',
    component: () => import('../views/Backstage/Backstage.vue'),
    children: [
      {
        path: '',
        name: 'Admin',
        component: () => import('../views/Backstage/Home.vue'),
        meta: { requiresAuth: true }
      },
      {
        path: '/increase',
        name: 'AddPeriodRole',
        component: () => import('../views/Backstage/AddPeriodRole.vue'),
        meta: { requiresAuth: true }
      },
      {
        path: '/working-hours/:roleId',
        name: 'RolePeriod',
        component: () => import('../views/Backstage/RolePeriod.vue'),
        meta: { requiresAuth: true }
      },
      {
        path: '/setting',
        name: 'Setting',
        component: () => import('../views/Backstage/Setting.vue'),
        meta: { requiresAuth: true }
      }
    ]
  }
]

const router = new VueRouter({
  routes
})

export default router
